export default { // consistent across mcom and bcom
  label1: 'Pick up in __BOSSDATE__ ',
  label2: "We'll ship this item to the store and alert you when it is ready.",
  label3: "We'll ship this item to the store and alert you when it arrives",
  bothInStoreAndCurbsideEligible: 'Available for in-store or curbside pickup.',
  onlyInStoreEligible: 'Available for in-store pickup only.',
  onlyCurbsideEligible: 'Available for curbside pickup only.',
};
